
const Leaderboards = () => {

    const { useState, useEffect } = React

    const [sortOrder, setSortOrder] = useState('asc'); 
    const sortData = (data) => {
        return data.sort((a, b) => {
            if (sortOrder === 'asc') {
                return a.thirdColumnValue - b.thirdColumnValue; // Assuming numerical values, modify as needed
            } else {
                return b.thirdColumnValue - a.thirdColumnValue;
            }
        });
    };

    const handleSort = (stat) => {
        
        setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
        // Assuming your data state is 'data', pass it to sortData
        const sortedData = sortData([...data]);
        setData(sortedData); // Update your data state with the sorted data
    };

    const [dataClutch, setDataClutch] = useState([])
    const [dataDominate, setDataDominate] = useState([])
    const [littleThings, setLittleThings] = useState([])
    const [thisAndThat, setThisAndThat] = useState([])

    const defaultTrait = "trait4"

    const [data, setData] = useState([])

    const [bestOfBestTeams, setBestOfBestTeams] = useState([])

    const [teamSelected, setTeamSelected] = useState(document.getElementById('team-leaderboards').getAttribute('data-team')?.toLowerCase())

    const initialTrait = document.getElementById('team-leaderboards')?.getAttribute('data-trait');
    const [traitSelected, setTraitSelected] = useState(initialTrait || defaultTrait);

    const traits = [
        { name: "Dominate from the jump", value: "trait1", label: "They Dominate From the jump", traitLabel: "Trait #1" },
        { name: "Clutch Factor", value: "trait2", label: "Clutch Factor", traitLabel: "Trait #2" },
        { name: "Little Things", value: "trait3", label: "Little Things", traitLabel: "Trait #3" },
        { name: "This and That", value: "trait4", label: "This and That", traitLabel: "Trait #4" }
    ];

    const [selectedTrait, setSelectedTrait] = useState({}); // Store the selected trait object

    const [top8, setTop8] = useState(0)
    const [top16, setTop16] = useState(0)
    const [bottom16, setBottom16] = useState(0)

    const [allTeams, setAllTeams] = useState([])

    const [leaderboards, setLeaderboards] = useState([])

    const [isMobile, setIsMobile] = useState(false);

    const [uniqueStats, setUniqueStats] = useState([])

    const cols = ["Rank", "Team"]
    const seasons = [2024, 2023, 2022]

    const [season, setSeason] = useState(() => {
        const seasonAttr = document.getElementById('team-leaderboards')?.getAttribute('data-season');
        const seasonNumber = Number(seasonAttr);
        return seasonNumber > 0 ? seasonNumber : 2024;
    });

    useEffect(() => {

        /** temp. should pull data once, check tops data. */

        loadData()
            .then(function (data) {

                setDataDominate(data.DominateLeaderboards)
                setDataClutch(data.ClutchLeaderboards)
                setLittleThings(data.LittleThings)
                setThisAndThat(data.ThisAndThat)

                if (traitSelected?.toLowerCase() === "trait1") {
                    data = data.DominateLeaderboards
                }
                else if (traitSelected?.toLowerCase() === "trait2") {
                    data = data.ClutchLeaderboards;
                }
                else if (traitSelected?.toLowerCase() === "trait3") {
                    data = data.LittleThings
                }
                else if (traitSelected?.toLowerCase() === "trait4") {
                    data = data.ThisAndThat
                }

                setData(data.sort((a, b) => {
                    if (a.rank === 0) return 1;
                    if (b.rank === 0) return -1;
                    return a.rank - b.rank;
                }));

                console.log("Data", data)

                UpdateTopLeaderboards(teamSelected, data)

                //const uniqueStats = data.reduce((stats, entry) => {
                //    stats.add(entry.stat);
                //    return stats;
                //}, new Set());

                const us = data.reduce((stats, entry) => {
                    // Exclude 'League Avg' entries
                    if (entry.teamname.toLowerCase() !== 'league avg') {
                        const uniqueEntry = {
                            stat: entry.stat,
                            stat_label: entry.stat_label,
                        };

                        stats.add(JSON.stringify(uniqueEntry));
                    }
                    return stats;
                }, new Set());

                console.log("US", us)

                const grpStats = [...us].map(entry => JSON.parse(entry));

                console.log("grpStats", grpStats)

                setUniqueStats(grpStats)

                /** get all teams dropdown */
                const groupedData = data.reduce((acc, entry) => {
                    const teamname = entry.teamname.toLowerCase();
                    if (teamname !== "league avg") {
                        if (!acc[teamname]) {
                            acc[teamname] = [];
                        }
                        acc[teamname].push(entry);
                    }
                    return acc;
                }, {});
                const teamnames = Object.keys(groupedData).sort((a, b) => {
                    if (a.match(/^\d/) && !b.match(/^\d/)) {
                        return 1;
                    } else if (!a.match(/^\d/) && b.match(/^\d/)) {
                        return -1;
                    } else {
                        return a.localeCompare(b);
                    }
                });
                const allTeamsWithAllOption = ["All Teams", ...teamnames];

                setAllTeams(allTeamsWithAllOption);

                /** best of best teams */
                const bestGrouped = data.reduce((result, item) => {
                    if (item.bestofbest === 1 && !result.includes(item.teamname)) {
                        result.push(item.teamname);
                    }
                    return result;
                }, []);
                setBestOfBestTeams(Object.values(bestGrouped))

                /** Leaderboards */
                const groupedLeaderboards = data.reduce((acc, curr) => {
                    const key = curr.stat;
                    if (!acc[key]) {
                        acc[key] = [];
                    }
                    acc[key].push(curr);
                    return acc;
                }, {});

                /*console.log(Object.values(groupedLeaderboards))*/

                setLeaderboards(Object.values(groupedLeaderboards))

            })
            .catch(function (e) {
                console.log(e)
            })

    }, [traitSelected, season])

    useEffect(() => {

        // Add an event listener to track window resize
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768); // Adjust the breakpoint as needed
        };

        // Initial check on mount
        handleResize();

        // Attach the event listener
        window.addEventListener('resize', handleResize);

        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const newSelectedTrait = traits.find(trait => trait.value === traitSelected) || {};
        setSelectedTrait(newSelectedTrait);
    }, [traitSelected, traits]);

    const colLeadWidthStyle = {
        wordWrap: "break-word",
        maxWidth: "150px",
        verticalAlign: "middle",
        fontSize: '14px'

    }

    const loadData = async () => {

        return new Promise((resolve, reject) => {
            fetch(`/NFL/GetTeamStatistics?season=${season}`).then(response => {
                if (response.ok) {
                    resolve(response.json())
                } else {
                    reject(new Error('error'))
                }
            }, error => {
                reject(new Error(error.message))
            })
        })

    }

    const formatPercentage = (value) => {

        if (selectedTrait.value === "trait2" || selectedTrait.value === "trait4") return value;

        return value
        //if (!value.includes('%')) {
        //    return value;
        //}

        //const floatValue = parseFloat(value);
        //const formattedValue = floatValue.toFixed(1);
        //return (`${formattedValue}%`)
    }

    const teamHandleClick = (tm) => {

        setTeamSelected(tm.toLowerCase())

        window.history.pushState({}, '', `?team=${tm}&trait=${traitSelected}&season=${season}`);
        UpdateTopLeaderboards(tm, data)

    }

    const UpdateTopLeaderboards = (tm, data) => {

        /** Top 8 - 16 - bottom 16 */
        const t8 = data.filter(x => x.teamname.toLowerCase() === tm && x.rank <= 8)
        setTop8(t8.length);

        const t6 = data.filter(x => x.teamname.toLowerCase() === tm && x.rank <= 16)
        setTop16(t6.length);

        const b6 = data.filter(x => x.teamname.toLowerCase() === tm && x.rank > 16)
        setBottom16(b6.length);

    }


    const traitHandleClick = (value) => {

        //window.history.pushState({}, '', `?team=${teamSelected}&trait=${value}`);
        window.history.pushState({}, '', `?team=${teamSelected}&trait=${value}&season=${season}`);
        setTraitSelected(value)
    }

    const handleSeasonSelect = (value) => {

        window.history.pushState({}, '', `?team=${teamSelected}&trait=${traitSelected}&season=${value}`);

        setSeason(Number(value))

    }



    return (
        <div className="container-fluid mt-0 table-responsive bg-white p-4">

            <div className="row justify-content-center align-items-start g-5 pb-4">

                <div className="col-lg-4">
                    <div className={`card-body mb-3 ${isMobile ? 'd-block' : 'd-none'}`}>
                        <div className="d-flex w-100 justify-content-center mb-3">
                            <h1 className="mb-1 fs-5 fw-bold">BEST OF THE BEST <br /> -- NFL TEAMS IN 2022</h1>
                        </div>
                        <div className="d-flex fs-5 w-100 justify-content-start">
                            <span className="text-muted">
                                <a href="https://insideedge1.substack.com/p/best-of-the-best-nfl-teams-2022?utm_campaign=post&utm_medium=web" target="_blank">
                                    Read More Here
                                </a>
                            </span>
                            <span className="mx-2">|</span>
                            <span className="text-muted">
                                <a target="_blank" href="https://www.youtube.com/playlist?list=PLuM86Nw638jT_o2sq5vgCgsjZI0ekPfWk">
                                    Watch the Videos
                                    <i aria-hidden="true" className="fab fa-youtube fs-5 text-danger ms-1">
                                    </i>
                                </a>
                            </span>
                        </div>
                    </div>

                    <div className="list-group">
                        <li className="list-group-item " aria-current="true">
                            <p className="my-3 fw-bold">
                                <h4 className="mb-1">
                                    <p className="text-capitalize fs-5">{`Common ${selectedTrait?.traitLabel}`}</p>
                                    <p className="text-uppercase fs-5">{selectedTrait?.label}</p>
                                </h4>
                            </p>
                            <ul className="list-group list-group-horizontal border-0 list-group-horizontal-nfl">

                                <li className="custom-letter-spacing px-0 list-group-item text-uppercase d-flex align-items-center border-0">
                                    <div className="list-group-item box-green-bestofbest text-uppercase d-flex align-items-center border-0 bg-bestofbest" />
                                    <h5 className="p-0 m-0 ms-2">Best of the best team</h5>
                                </li>
                            </ul>
                            <h6>Ten leaderboards related to performance at the beginning of games</h6>
                        </li>
                    </div>
                </div>

                <div className={`col-lg-5 d-flex flex-column align-items-start ${isMobile ? 'd-none' : 'd-block'}`}>
                    <div className="card border-0">
                        <div className="card-body p-0">
                            <div className="d-flex w-100 justify-content-start">
                                <h3 className="mb-1 fs-5">BEST OF THE BEST -- NFL TEAMS IN 2022</h3>
                            </div>
                            <div className="d-flex fs-4 w-100 justify-content-start">
                                <span className="text-muted">
                                    <a href="https://insideedge1.substack.com/p/best-of-the-best-nfl-teams-2022?utm_campaign=post&utm_medium=web" target="_blank">
                                        Read More Here
                                    </a>
                                </span>
                                <span className="mx-2">|</span>
                                <span className="text-muted">
                                    <a href="https://www.youtube.com/playlist?list=PLuM86Nw638jT_o2sq5vgCgsjZI0ekPfWk">
                                        Watch the Videos
                                        <i aria-hidden="true" className="fab fa-youtube fs-5 text-danger ms-1">
                                        </i>
                                    </a>
                                </span>
                            </div>

                        </div>
                        <div className="card-body px-0">
                            <div className="row">
                                <div className="col-md-4 d-flex align-items-end"> {/* Use col-md-6 and align-items-end */}
                                    <div className="w-100"> {/* Set width to 100% */}
                                        <div className="text-uppercase mb-2">
                                            <h5 className="m-0 text-start">Highlight A Team</h5>
                                        </div>
                                        <select
                                            onChange={(e) => teamHandleClick(e.target.value)}
                                            value={teamSelected}
                                            className="form-select form-select-lg w-100 text-capitalize text-sm"
                                        >
                                            {allTeams.map((t, idx) => (
                                                <option
                                                    key={'allteams1' + t + idx}
                                                    className="option-padding text-capitalize"
                                                    value={t.toLowerCase()}
                                                >
                                                    {t}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-5 d-flex align-items-end">

                                    <div className="w-100"> {/* Set width to 100% */}
                                        <div className="text-uppercase mb-2">
                                            <h5 className="m-0 text-start">Choose a leaderboard</h5>
                                        </div>
                                        <select
                                            onChange={(e) => traitHandleClick(e.target.value)}
                                            value={traitSelected}
                                            className="form-select form-select-lg w-100 text-sm"
                                        >
                                            {traits.map((trait) => (
                                                <option key={trait.value} value={trait.value}>
                                                    {trait.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                </div>

                                <div className="col-md-3 d-flex align-items-end"> {/* Use col-md-6 and align-items-end */}
                                    <div className="w-100"> {/* Set width to 100% */}
                                        <div className="text-uppercase mb-2">
                                            <h5 className="m-0 text-start">Season</h5>
                                        </div>
                                        <select
                                            onChange={(e) => handleSeasonSelect(e.target.value)}
                                            value={season}
                                            className="form-select form-select-lg w-100 text-capitalize text-sm"
                                        >
                                            {seasons.map((s, idx) => (
                                                <option
                                                    key={'season' + s + idx}
                                                    className="option-padding text-capitalize"
                                                    value={s}
                                                >
                                                    {s}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

                <div className="col-lg-3">
                    <table className="table table-bordered table-lg my-0 mx-0">

                        <tbody>
                            <tr>
                                <td colspan="2" className="text-center text-uppercase fs-4 bg-light">{teamSelected}</td>
                            </tr>
                            <tr>
                                <td>{top8}</td>
                                <td>Top 8 in NFL (top 75th percentile)</td>
                            </tr>
                            <tr>
                                <td>{top16}</td>
                                <td>Top 16 in NFL (Top 50th Percentile)</td>
                            </tr>
                            <tr>
                                <td>{bottom16}</td>
                                <td>Bottom 16 in NFL (Bottom 50th Percentile)</td>
                            </tr>
                        </tbody>
                    </table>

                    <div className={`card border-0 pt-4 ${isMobile ? 'd-block' : 'd-none'}`}>

                        <div className="card-body px-0">
                            <div className="row gap-y-4">
                                <div className="col-md-4 d-flex align-items-end"> {/* Use col-md-6 and align-items-end */}
                                    <div className="w-100"> {/* Set width to 100% */}
                                        <div className="text-uppercase mb-2">
                                            <h5 className="m-0 text-start">Highlight A Team</h5>
                                        </div>
                                        <select
                                            onChange={(e) => teamHandleClick(e.target.value)}
                                            value={teamSelected}
                                            className="form-select form-select-lg w-100 text-capitalize text-sm text-center"
                                        >
                                            {allTeams.map((t, idx) => (
                                                <option
                                                    key={'allteams1' + t + idx}
                                                    className="option-padding text-capitalize"
                                                    value={t.toLowerCase()}
                                                >
                                                    {t}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-5 d-flex align-items-end">

                                    <div className="w-100"> {/* Set width to 100% */}
                                        <div className="text-uppercase mb-2">
                                            <h5 className="m-0 text-start">Choose a leaderboard</h5>
                                        </div>
                                        <select
                                            onChange={(e) => traitHandleClick(e.target.value)}
                                            value={traitSelected}
                                            className="form-select form-select-lg w-100 text-sm text-center"
                                        >
                                            {traits.map((trait) => (
                                                <option key={trait.value} value={trait.value}>
                                                    {trait.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                </div>

                                <div className="col-md-3 d-flex align-items-end"> {/* Use col-md-6 and align-items-end */}
                                    <div className="w-100"> {/* Set width to 100% */}
                                        <div className="text-uppercase mb-2">
                                            <h5 className="m-0 text-start">Season</h5>
                                        </div>
                                        <select
                                            onChange={(e) => handleSeasonSelect(e.target.value)}
                                            value={season}
                                            className="form-select form-select-lg w-100 text-capitalize text-sm text-center"
                                        >
                                            {seasons.map((s, idx) => (
                                                <option
                                                    key={'season' + s + idx}
                                                    className="option-padding text-capitalize"
                                                    value={s}
                                                >
                                                    {s}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

            <div className="row justify-content-start align-items-end g-5">
                {uniqueStats.map((s, index) => (
                    <div key={`${s.stat + index}`} className="col-md-3">
                        <div className="card shadow-sm border-0">
                            <div
                                className="card-header text-uppercase text-center bg-dark text-white"
                                style={{ letterSpacing: "0.05rem", fontSize: "13px" }}
                            >
                                {s.stat}
                            </div>
                            <div className="card-body">
                                <div className="row row-th fw-bold mb-2 text-sm" style={{ borderBottom: "1px solid black" }}>
                                    <div className="col-2 text-center">Rank</div>
                                    <div className="col-5">Team</div>
                                    <div onClick={handleSort} className="col-4 text-center">{s.stat_label}</div>
                                    {/*<th onClick={handleSort}>Third Column Name</th>*/}
                                </div>
                                {
                                    leaderboards[index]?.map((t, idx) => (
                                        <div

                                            className={`row row-item ${idx % 2 === 0 ? 'bg-light' : ''} ${t.teamname.toLowerCase() === "league avg" ? "fw-bold" : ""}`}
                                            key={`second_${t.teamname + idx}`}
                                        >
                                            <div className="col-2 text-center">
                                                {t.rank !== 0 && t.rank}
                                            </div>
                                            <div
                                                className={`col-5 ${teamSelected === t.teamname.toLowerCase()
                                                    ? 'bg-tmselected'
                                                    : bestOfBestTeams.includes(t.teamname) && 'bg-bestofbest'
                                                    }`}
                                            >
                                                {t.teamname}
                                            </div>
                                            <div
                                                className={`col-4 text-center ${teamSelected === t.teamname.toLowerCase() && 'bg-tmselected'
                                                    }`}
                                            >
                                                {formatPercentage(t.value)}
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                ))}
            </div>

        </div>
    )

}


const root = ReactDOM.createRoot(document.getElementById('team-leaderboards'));
root.render(
    <Leaderboards />
);

const ContentComponent = () => {

    return (

        <div className={`card-body mb-3 ${isMobile ? 'd-block' : 'd-none'}`}>
            <div className="d-flex w-100 justify-content-start">
                <h1 className="mb-1 fs-5">BEST OF THE BEST <br /> -- NFL TEAMS IN 2022</h1>
            </div>
            <div className="d-flex fs-6 w-100 justify-content-start">
                <span className="text-muted">
                    <a target="_blank" href="https://insideedge1.substack.com/p/best-of-the-best-2022-nfl-season">
                        Read More Here
                    </a>
                </span>
                <span className="mx-2">|</span>
                <span className="text-muted">
                    <a target="_blank" href="https://www.youtube.com/playlist?list=PLuM86Nw638jT_o2sq5vgCgsjZI0ekPfWk">
                        Watch the Videos
                        <i aria-hidden="true" className="fab fa-youtube fs-5 text-danger ms-1">
                        </i>
                    </a>
                </span>
            </div>
        </div>

    )

}